import React from 'react';

interface TextComponentProps {
  title: string;
  description?: string;
}

const FlyoutText: React.FC<TextComponentProps> = ({ title, description }) => {
  return (
    <div className="text">
      <div className="flyout-text">
        <div>{title}</div>
        {description && <div>{description}</div>}
      </div>
    </div>
  );
};

export default FlyoutText;
